import type {
  ExtendedGridEventAppearance,
  GridEventType,
} from 'modules/shift_management/utils/TimeGridTable/transformEvents'

import { HolidayCard } from 'modules/shift_management/components/ShiftManagement/Content/Body/ShiftManagementTimeGrid/eventCards/HolidayCard'
import { LeaveCard } from 'modules/shift_management/components/ShiftManagement/Content/Body/ShiftManagementTimeGrid/eventCards/LeaveCard'
import { RestDayCard } from 'modules/shift_management/components/ShiftManagement/Content/Body/ShiftManagementTimeGrid/eventCards/RestDayCard'
import { ShiftCard } from 'modules/shift_management/components/ShiftManagement/Content/Body/ShiftManagementTimeGrid/eventCards/ShiftCard'
import { TimeOffSummaryCard } from 'modules/shift_management/components/ShiftManagement/Content/Body/ShiftManagementTimeGrid/eventCards/TimeOffSummaryCard'
import type { ReactNode } from 'react'

import type { CardAppearance } from 'modules/shift_management/components/ShiftManagement/TimeGridTable/types'

export interface EventCardSpec<TEvent> {
  getAppearance(event: TEvent): CardAppearance
  render(event: TEvent): ReactNode
}

export type EventByType<TType extends GridEventType> = Extract<
  ExtendedGridEventAppearance,
  { type: TType }
>

export type EventCardSpecsByType = {
  [K in GridEventType]: EventCardSpec<EventByType<K>>
}

const eventCards: EventCardSpecsByType = {
  shift: ShiftCard,
  leave: LeaveCard,
  rest_day: RestDayCard,
  holiday: HolidayCard,
  time_off_summary: TimeOffSummaryCard,
}

const resolveCard = (
  eventType: GridEventType
): EventCardSpec<ExtendedGridEventAppearance> => {
  return eventCards[eventType]
}

export { resolveCard }
